export default __webpack_public_path__ + "static/media/Inter-UI-SemiBoldItalic.25681b8f.woff2";